import React, { useState } from "react";

const steps = [
  {
    title: "User Registration & Login",
    desc: "A user creates an account on Think5Whys and logs into the platform to access HAFH.",
  },
  {
    title: "Select HAFH Module",
    desc: "User enters the Home Away From Home (HAFH) section and selects their journey path.",
  },
  {
    title: "Director Activation",
    desc: "A Director role is requested and verified before activation. Once approved, full dashboard access is granted.",
  },
  {
    title: "Coordinator Onboarding",
    desc: "Director can invite Coordinators who must be registered users and verified before activation.",
  },
  {
    title: "Expansion Roles Setup",
    desc: "Trustee, Institution, and Owner roles are added with proper verification and system approval.",
  },
  {
    title: "Hostel Setup (Owner)",
    desc: "Owner creates hostel records and generates unique hostel codes for system mapping.",
  },
  {
    title: "Manager Operations",
    desc: "Manager handles daily operations and can onboard mess, transport, and students.",
  },
  {
    title: "Student Onboarding",
    desc: "Students join using hostel code or bulk upload. Approval is required before activation.",
  },
  {
    title: "Parent Linking",
    desc: "Once a student is active, their parent profile can be connected to the system.",
  },
  {
    title: "HUMA Monitoring Layer",
    desc: "HUMA roles are monitoring users added for supervision across the ecosystem.",
  },
  {
    title: "Admin Control",
    desc: "Admin oversees all onboarding, approvals, role assignments, and can override any process.",
  },
  {
    title: "System Hierarchy",
    desc: "Admin → Director → Coordinator → Owner → Manager → Students → Parents with strict role structure.",
  },
  {
    title: "Onboarding Workflow Engine",
    desc: "Every action goes through a structured approval process before becoming active in the system.",
  },
];

const HAFHOnboardingProcess = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 p-4">

      {/* Header */}
      <div className="text-center mb-6">
        <h1 className="text-lg lg:text-2xl font-bold">
          🚀 HAFH Onboarding Journey
        </h1>
        <p className="text-xs lg:text-sm text-slate-200">
          Complete user journey from registration to full ecosystem access
        </p>
      </div>

      {/* Stepper */}
      <div className="space-y-3">
        {steps.map((step, index) => (
          <div
            key={index}
            onClick={() => setActiveStep(index)}
            className={`p-3 rounded-lg cursor-pointer border transition
              ${
                activeStep === index
                  ? "bg-cyan-700 text-gray-100 font-bold"
                  : "bg-slate-900 border-slate-700 text-slate-100"
              }
            `}
          >
            <div className="flex items-center justify-between">
              <span className="text-xs lg:text-sm font-semibold text-yellow-200">
                {step.title}
              </span>

              <span className="text-xs text-gray-100">
                {activeStep === index ? "● Active" : "○"}
              </span>
            </div>

            {/* Description (ONLY SHOW FOR ACTIVE STEP) */}
            {activeStep === index && (
              <p className="mt-2 text-xs lg:text-sm text-gray-100">
                {step.desc}
              </p>
            )}
          </div>
        ))}
      </div>

      {/* Info Panel */}
      <div className="mt-6 bg-slate-900 p-4 rounded-xl text-xs lg:text-sm text-slate-300">
        <p className="text-gray-100">
          This flow represents the complete onboarding journey inside the HAFH system.
          Each step must be completed and approved before moving to the next stage.
        </p>
      </div>

    </div>
  );
};

export default HAFHOnboardingProcess;